import { render, staticRenderFns } from "./ParamCompare.vue?vue&type=template&id=257064ce&scoped=true"
import script from "./ParamCompare.vue?vue&type=script&lang=js"
export * from "./ParamCompare.vue?vue&type=script&lang=js"
import style0 from "./ParamCompare.vue?vue&type=style&index=0&id=257064ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257064ce",
  null
  
)

export default component.exports